<template>

	<div class="user_wbox">
		<div class="inter">
			<div class="div1 t-flex">
				<div class="fl">

					<div class="user_menu2">
						<div class="user_menu_div1">
							<div class="wp1" :class="{ 'active': menu_index == 1 }">
								<div class="ic">
									<img src="@/assets/image/order_ic2.png" />
								</div>
								<span>我的租赁订单</span>
							</div>
							<div class="user_menu_list">
								<div class="item" :class="{ 'active': menu_index == 1 && status == -1 }"
									@click="choseOrder(1, -1)">全部订单</div>
								<div class="item" :class="{ 'active': menu_index == 1 && status == 1 }"
									@click="choseOrder(1, 1)">进行中</div>
								<div class="item" :class="{ 'active': menu_index == 1 && status == 2 }"
									@click="choseOrder(1, 2)">已取消</div>
								<div class="item" :class="{ 'active': menu_index == 1 && status == 3 }"
									@click="choseOrder(1, 3)">交易完成</div>
							</div>
						</div>

						<div class="user_menu_div1">
							<div class="wp1" :class="{ 'active': menu_index == 2 }">
								<div class="ic"><img src="@/assets/image/order_ic.png" /></div>
								<span>我的出租订单</span>
							</div>
							<div class="user_menu_list">
								<div class="item" :class="{ 'active': menu_index == 2 && status == -1 }"
									@click="choseOrder(2, -1)">全部订单</div>
								<div class="item" :class="{ 'active': menu_index == 2 && status == 1 }"
									@click="choseOrder(2, 1)">进行中</div>
								<div class="item" :class="{ 'active': menu_index == 2 && status == 2 }"
									@click="choseOrder(2, 2)">已取消</div>
								<div class="item" :class="{ 'active': menu_index == 2 && status == 3 }"
									@click="choseOrder(2, 3)">交易完成</div>
							</div>
						</div>

					</div>
				</div>
				<div class="fr fr2">

					<div class="order_mobile_list" v-if="isMobile">
						<div class="item" v-for="(item, index) in list">
							<div class="text_1">
								<div class="sp1">编号 {{ item.id }}</div>
								<div class="sp2" v-if="item.is_sell != 2 && item.status == 'pulloff'">审核失败</div>
								<div class="sp2" v-if="item.is_sell != 2 && item.status == 'hidden'">待审核</div>
								<div class="sp2" v-if="item.is_sell == 2">已出售</div>
							</div>
							<div class="text_2">
								<div class="image">
									<img src="@/assets/image/tu_biao.png" />
								</div>
								<div class="text">
									<div class="p1">{{ item.archives.title }}</div>
									<div class="p2">
										<div class="item_text">
											<span class="sp1">创建时间:</span>
											<span class="sp2">{{ item.createtime }}</span>
										</div>
										<div class="item_text">
											<span class="sp1">备注:</span>
											<span class="sp2">{{ item.beizhu }}</span>
										</div>
									</div>
									<div class="p2">
										<div class="item_text">
											<span class="sp1">售价:</span>
											<span class="sp2">{{ item.price }}元</span>
										</div>
										<div class="item_text">
											<span class="sp1">区服:</span>
											<span class="sp2">({{ item.qufu_text }})</span>
										</div>
									</div>
								</div>

							</div>

							<div class="text_3">
								<div class="con" v-if="item.is_sell == 0 && menu_index == 2">
									<span class="sp1" @click="xiajia(index, item)"
										v-if="item.status == 'normal'">下架</span>
									<span class="sp1" @click="shangjia(index, item)"
										v-if="item.status == 'pulloff'">上架</span>

									<router-link class="sp2" target="_blank"
										:to="{ path: '/sell', query: { id: item.id } }">
										编辑
									</router-link>
								</div>
								<div class="con order-actions" v-if="menu_index == 1">
									<template v-if="item.status == '0'">
										<span class="sp1" @click="payOrderGo(item.id)">去支付</span>
										<span class="sp2" @click="cancel(item.id)">取消</span>
									</template>
									<span class="sp3" v-if="item.status == '2'">已取消</span>
								</div>

								
								
							</div>
						</div>
					</div>

					<div class="my_goods_list" v-if="!isMobile">
						<div class="item" v-for="(item, index) in list">
							<div class="con1">
								<div class="text_1">

									<div class="sp2">订单编号:{{ item.order_no }}</div>
									<div class="sp3">复制</div>
								</div>
								<div class="text_2">
									商品操作
								</div>
							</div>
							<div class="con2">
								<div class="text_1">
									<div class="image">
										<img src="@/assets/image/tu_biao.png" />
									</div>
									<div class="text">
										<div class="p1">
											{{ item.archives.title }}</div>
										<div class="p2">
											<div class="item_text">
												<span class="sp1">下单时间:</span>
												<span class="sp2">{{ item.createtime }}</span>
											</div>
											<div class="item_text">
												<span class="sp1">备注:</span>
												<span class="sp2">{{ item.beizhu }}</span>
											</div>
										</div>
										<div class="p2">
											<div class="item_text">
												<span class="sp1">订单金额:</span>
												<span class="sp2">{{ item.price }}元</span>
											</div>
											<!-- <div class="item_text">
												<span class="sp1">游戏区服:</span>
												<span class="sp2">三角洲行动(QQ)</span>
											</div> -->
										</div>
									</div>
								</div>
								<div class="text_2">
									<div class="con order-actions" v-if="menu_index == 1">
										<template v-if="item.status == '0'">
											<span class="sp1" @click="payOrderGo(item.id)">去支付</span>
											<span class="sp2" @click="cancel(item.id)">取消</span>
										</template>
										<template v-if="item.status == '1' || item.status == '3'">
											<span class="sp1 kefu-btn" @click="showKefu(item.id)">联系客服</span>
										</template>
										<span class="sp3" v-if="item.status == '2'">已取消</span>
									</div>


									<div class="con" v-if="item.is_sell == 0 && menu_index == 2">
										<span class="sp1" @click="xiajia(index, item)"
											v-if="item.status == 'normal'">下架</span>
										<span class="sp1" @click="shangjia(index, item)"
											v-if="item.status == 'pulloff'">上架</span>

										<router-link class="sp2" target="_blank"
											:to="{ path: '/sell', query: { id: item.id } }">
											编辑
										</router-link>
									</div>


								</div>
							</div>
						</div>
					</div>

					<el-empty description="暂无数据" v-if="list.length == 0"></el-empty>

					<el-pagination class="pagebox" v-if="list.length > 0 && !isMobile" background @size-change="handleSizeChange"
						@current-change="handleCurrentChange" :current-page="current_page"
						:page-sizes="[10, 20, 30, 40, 50]" :page-size="10"
						layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
					<el-pagination class="pagebox" v-if="list.length > 0 && isMobile" background @size-change="handleSizeChange"
						@current-change="handleCurrentChange" :current-page="current_page"
						:page-sizes="[10, 20, 30, 40, 50]" :page-size="10"
						layout="total, prev, pager, next" :total="total">
					</el-pagination>

				</div>
			</div>
		</div>


		<el-dialog :visible.sync="payvisible" :center="true" custom-class="pay_dialog" title="收银台" width="544px"
			destroy-on-close @closed="payvisible = false">
			<div class="pay_dialog_page">
				<div class="scan_operat">
					<div class="scan_area" v-if="pay_type == 1">
						<p class="scan_area_title">请打开支付宝扫一扫</p>
						<div class="qr-box">
							<div ref="qrcode" id="qrcodePay" style="display: inline-block;">


							</div>

						</div>
						<p class="pay_risk" style="display: none;">订单已超时取消，请重新下单</p>
						<div class="pay_risk">
							<el-statistic format="mm:ss" :value="pay_info.expiretime * 1000" time-indices title="">
							</el-statistic>
							后二维码失效
						</div>
					</div>
					<div class="scan_area" v-if="pay_type == 2">
						<p class="scan_area_title">请打开微信扫一扫</p>
						<div class="qr-box">
							<div ref="qrcode" id="qrcodePay" style="display: inline-block;">


							</div>

						</div>
						<p class="pay_risk" style="display: none;">订单已超时取消，请重新下单</p>
						<div class="pay_risk" v-if="pay_show">
							<el-statistic format="mm:ss" :value="pay_info.expiretime * 1000" time-indices title="">
							</el-statistic>
							后二维码失效
						</div>
					</div>
					<div class="scan_control">
						<p class="scan_control_price">
							应付金额：
							<span>¥{{ pay_info.price }}</span>
						</p>
						<div class="scan_control_option" @click="openPay(1)">
							<div>

								<img :src="require(`@/assets/image/alipay.png`)" alt="ALIPAY">
								<span>支付宝</span>
							</div> <img v-if="pay_type == 1" :src="require(`@/assets/image/radio_icon_active.png`)"
								alt="选择支付方式" class="option_single_choice">
							<img v-if="pay_type != 1" :src="require(`@/assets/image/radio_icon.png`)" alt="选择支付方式"
								class="option_single_choice">

						</div>
						<!-- <div class="scan_control_option" @click="openPay(2)">
							<div>
								<img :src="require(`@/assets/image/wechat.png`)" alt="wechat">
								<span>微信支付</span>
							</div> <img v-if="pay_type == 2" :src="require(`@/assets/image/radio_icon_active.png`)"
								alt="选择支付方式" class="option_single_choice">
							<img v-if="pay_type != 2" :src="require(`@/assets/image/radio_icon.png`)" alt="选择支付方式"
								class="option_single_choice">
						</div> -->

						<p class="scan_control_tips">为确保您当前交易的安全，扫描二维码后会进行安全验证！</p>
					</div>
				</div>
			</div>
		</el-dialog>

		<el-dialog title="联系客服" :visible.sync="kefuVisible" width="480px" custom-class="kefu-dialog">
			<div v-if="kefuLoading" class="kefu-loading">正在加载...</div>
			<div class="kefu-content" v-else-if="kefuInfo">
				<div class="kefu-header">
					<div class="kefu-title">客服分配成功</div>
				</div>
				<div class="kefu-tip">
					<i class="el-icon-success"></i>
					<span>您的账号已提交，客服会指导您完成后续操作</span>
				</div>
				<div class="kefu-info">
					<div class="info-row" v-if="kefuInfo.name">
						<span class="info-label">客服姓名：</span>
						<span class="info-value">{{ kefuInfo.name }}</span>
					</div>
					<div class="info-row" v-if="kefuInfo.wechat">
						<span class="info-label">客服微信：</span>
						<span class="info-value">{{ kefuInfo.wechat }}</span>
						<span class="copy-btn" @click="copyText(kefuInfo.wechat)">复制</span>
					</div>
					<div class="info-row" v-if="kefuInfo.kefu_code">
						<span class="info-label">客服编号：</span>
						<span class="info-value">{{ kefuInfo.kefu_code }}</span>
						<span class="copy-btn" @click="copyText(kefuInfo.kefu_code)">复制</span>
					</div>
				</div>
				<div class="kefu-qrcode" v-if="kefuInfo.qrcode">
					<div class="qrcode-label">扫码添加客服：</div>
					<img :src="kefuInfo.qrcode" class="qrcode-img" />
				</div>
			</div>
			<div v-else class="kefu-empty">暂无客服信息</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="kefuVisible = false">知道了</el-button>
			</div>
		</el-dialog>

	</div>

</template>


<script>
import usermenu from '@/components/dialogs/usermenu'
import {
	Notification,
	Message
} from 'element-ui'
import moment from 'moment';
export default {
	components: {
		usermenu
	},
	data() {
		return {
			status: -1,

			list: [],
			current_page: 1,
			pagesize: 10,
			total: 0,
			last_page: 0,
			menu_index: 1,
			payvisible: false,
			pay_info: {},
			pay_type: 1,
			order_id: 0,
			pay_show: false,
			kefuVisible: false,
			kefuInfo: null,
			kefuLoading: false



		}
	},
	computed: {
		userinfo() {
			return this.$store.getters.userinfo
		},
		login() {
			return this.$store.getters.login
		},
		open_login() {
			return this.$store.getters.open_login
		},

		isMobile() {
			return this.$store.getters.isMobile
		},
		gamelist() {
			return this.$store.getters.gamelist
		},
		allGameList() {
			return this.$store.getters.allGameList
		},
		config() {
			return this.$store.getters.config
		},
	},
	created: function (data) {

		this.current_page = 1;
		this.pagesize = 10;
		this.addRandomData(this.current_page);

	},
	mounted: function() {
		// 页面挂载完成后检查URL参数，支付成功后自动弹出客服弹窗
		this.checkOrderStatus();
	},
	watch: {
		$route() {
			this.checkOrderStatus();
		}
	},
	methods: {
		checkOrderStatus() {
			// 检查URL参数中是否有订单ID
			// 参数可能在 hash 后面，需要手动解析
			const urlParams = new URLSearchParams(window.location.search);
			const hashParams = new URLSearchParams(window.location.hash.split('?')[1] || '');
			
			const orderId = this.$route.query.order_id || this.$route.query.id || urlParams.get('order_id') || hashParams.get('order_id');
			const outTradeNo = this.$route.query.out_trade_no || urlParams.get('out_trade_no') || hashParams.get('out_trade_no');
			
			console.log('checkOrderStatus - URL:', window.location.href);
			console.log('checkOrderStatus - orderId:', orderId);
			console.log('checkOrderStatus - outTradeNo:', outTradeNo);

			if (orderId && !isNaN(orderId)) {
				console.log('检测到支付成功返回，自动显示客服弹窗，订单ID:', orderId);
				setTimeout(() => {
					this.showKefu(orderId);
				}, 500);
			} else if (outTradeNo) {
				console.log('检测到支付宝订单号，自动显示客服弹窗，支付订单号:', outTradeNo);
				setTimeout(() => {
					this.showKefuByPayNo(outTradeNo);
				}, 500);
			}
		},
		showKefuByPayNo(payNo) {
			this.kefuInfo = null;
			this.kefuLoading = true;
			this.kefuVisible = true;
			this.rq.requests.post("api/game/order/getOrderByPayNo", {
				pay_no: payNo,
			}).then(res => {
				this.kefuLoading = false;
				if (res.code == 1 && res.data) {
					console.log('客服信息:', res.data.kefu);
					this.kefuInfo = res.data.kefu || null;
				}
			}).catch(error => {
				this.kefuLoading = false;
				this.kefuInfo = null;
			})
		},
		showKefu(orderId) {
			this.kefuInfo = null;
			this.kefuLoading = true;
			this.kefuVisible = true;
			this.rq.requests.post("api/game/order/detail", {
				id: orderId,
			}).then(res => {
				this.kefuLoading = false;
				if (res.code == 1 && res.data) {
					console.log('客服信息:', res.data.kefu);
					this.kefuInfo = res.data.kefu || null;
				}
			}).catch(error => {
				this.kefuLoading = false;
				this.kefuInfo = null;
			})
		},
		copyText(text) {
			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard.writeText(text).then(() => {
					this.$message.success('已复制到剪贴板');
				}).catch(() => {
					this.fallbackCopy(text);
				})
			} else {
				this.fallbackCopy(text);
			}
		},
		fallbackCopy(text) {
			const textarea = document.createElement('textarea');
			textarea.value = text;
			textarea.style.position = 'fixed';
			textarea.style.opacity = '0';
			document.body.appendChild(textarea);
			textarea.select();
			try {
				document.execCommand('copy');
				this.$message.success('已复制到剪贴板');
			} catch (err) {
				this.$message.error('复制失败');
			}
			document.body.removeChild(textarea);
		},
		cancel(id,index) {
			var that = this;
			this.rq.requests.post("api/game/order/cancel", {
				id: id,
			}).then(res => {
				if (res.code == 1) {
					Message.success({
						message: "取消成功",
						duration: 3000
					})
					location.reload()
				} else {
					Message.error({
						message: res.msg,
						duration: 3000,
					})
				}


			}).catch(error => {

			})
		},

		payOrderGo(item){
			var that = this
			if(!this.isMobile){
				that.payOrder(item)
			}else{
				that.payOrderMobile(item)
			}
		},
		payOrderMobile(id) {
			var that = this;
			this.rq.requests.post("api/game/Order/payOrder2", {
				id: id,
				pay_type: this.pay_type
			}).then(res => {
				if (res.code == 1) {
					open('http://api.kkzh.com/index/index/alipay?id='+res.data.id)
				}
			}).catch(res => {
				Message.error({
					message: res.msg,
					duration: 3000,
					offset: "580"
				})
			})
		},
		payOrder(item) {
			var id = item
			var that = this;
			this.rq.requests.post("api/game/Order/payOrder", {
				id: id,
				pay_type: this.pay_type
			}).then(res => {
				if (res.code == 1) {
					that.pay_show = false
					open('http://api.kkzh.com/index/index/alipay?id='+res.data.id)
					return;
					that.payvisible = true
					that.pay_info = res.data
					that.pay_show = true
					setTimeout(function () {
						var qrcodeElement = document.getElementById("qrcodePay");
						qrcodeElement.innerHTML = "";
						if (that.pay_type == 1) {
							new QRCode(document.getElementById("qrcodePay"), {
								text: that.pay_info.pay.qr_code,
								width: 130,
								height: 130
							});

						}

						if (that.pay_type == 2) {
							new QRCode(document.getElementById("qrcodePay"), {
								text: that.pay_info.pay.code_url,
								width: 130,
								height: 130
							});
						}


					}, 500);

					const intervalId = setInterval(() => {
						this.rq.requests.post("api/game/order/detail", {
							id: id,
						}).then(res => {
							if (res.data.status == '1') {
								clearInterval(intervalId);
								that.$router.push("/order")
							}
						}).catch(error => {
							clearInterval(intervalId);
						})
					}, 5000);
				}
			}).catch(res => {
				Message.error({
					message: res.msg,
					duration: 3000,
					offset: "580"
				})
			})
		},
		choseOrder(index, status) {
			this.menu_index = index
			this.status = status
			this.current_page = 1;
			this.pagesize = 10;
			this.addRandomData(this.current_page);
		},


		handleSizeChange(val) {

			this.pagesize = val;
			this.addRandomData(this.current_page);
		},
		handleCurrentChange(val) {
			this.current_page = val;
			this.addRandomData(this.current_page);
		},

		addRandomData(current_page) {
			this.loading = true;
			var that = this;
			this.list = []




			this.rq.requests.post("api/game/order/mylist", {
				menu_index: that.menu_index,
				status: that.status,
				page: current_page,
				pagesize: that.pagesize,
			}).then(res => {
				that.last_page = res.data.last_page;
				that.current_page = res.data.current_page;
				that.total = res.data.total;


				that.list = res.data.data;
				that.loading = false


			}).catch(error => {

			})
		},


	}


}
</script>

<style scoped>
.order-actions {
	display: flex;
	align-items: center;
	gap: 8px;
}
.order-actions .sp3 {
	color: #999;
	font-size: 14px;
}
.order-actions .kefu-btn {
	background: #508aff;
	color: #fff;
	padding: 4px 12px;
	border-radius: 4px;
	cursor: pointer;
}
.kefu-dialog {
	border-radius: 12px;
}
.kefu-dialog .kefu-loading,
.kefu-dialog .kefu-empty {
	text-align: center;
	padding: 40px 0;
	color: #909399;
	font-size: 14px;
}
.kefu-dialog .kefu-content {
	padding: 0;
}
.kefu-dialog .kefu-header {
	text-align: center;
	margin-bottom: 20px;
}
.kefu-dialog .kefu-header .kefu-title {
	font-size: 20px;
	font-weight: bold;
	color: #303133;
}
.kefu-dialog .kefu-tip {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	padding: 12px 16px;
	background: #f0f9eb;
	border-radius: 8px;
	color: #67c23a;
	font-size: 14px;
	margin-bottom: 20px;
}
.kefu-dialog .kefu-tip .el-icon-success {
	font-size: 18px;
}
.kefu-dialog .kefu-info {
	background: #f5f7fa;
	border-radius: 12px;
	padding: 20px;
	margin-bottom: 20px;
}
.kefu-dialog .kefu-info .info-row {
	display: flex;
	align-items: center;
	margin-bottom: 16px;
	font-size: 14px;
	flex-wrap: wrap;
}
.kefu-dialog .kefu-info .info-row:last-child {
	margin-bottom: 0;
}
.kefu-dialog .kefu-info .info-label {
	color: #909399;
	min-width: 90px;
}
.kefu-dialog .kefu-info .info-value {
	color: #303133;
	flex: 1;
	word-wrap: break-word;
	word-break: break-all;
	min-width: 0;
}
.kefu-dialog .kefu-info .copy-btn {
	background: #409eff;
	color: #fff;
	padding: 4px 12px;
	border-radius: 4px;
	font-size: 12px;
	margin-left: 12px;
	cursor: pointer;
	flex-shrink: 0;
}
.kefu-dialog .kefu-qrcode {
	display: flex;
    margin-bottom: 20px;
    flex-wrap: wrap;
    flex-direction: column;
}
.kefu-dialog .kefu-qrcode .qrcode-label {
	display: block;
	font-size: 14px;
	color: #606266;
	margin-bottom: 16px;
}
.kefu-dialog .kefu-qrcode .qrcode-img {
	display: block;
	margin: 0 auto;
	width: 200px;
	height: 200px;
	border-radius: 8px;
}
.kefu-dialog .dialog-footer {
	text-align: center;
}
.kefu-dialog .dialog-footer .el-button {
	width: 100%;
}
</style>